import React from 'react';
import { ChevronDown, Sparkles } from 'lucide-react';

const ScrollForMore = () => {
  const scrollToFeatures = () => {
    const featuresSection = document.getElementById('features-deep-dive');
    if (featuresSection) {
      featuresSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="py-12 bg-gradient-to-b from-slate-950 to-slate-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 mb-4">
          <Sparkles className="w-5 h-5 text-emerald-400" />
          <span className="text-emerald-400 font-medium">Want to learn more?</span>
          <Sparkles className="w-5 h-5 text-emerald-400" />
        </div>
        
        <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">
          Scroll below for a deeper dive into our platform features
        </h3>
        
        <p className="text-slate-400 mb-6 max-w-2xl mx-auto">
          Discover everything included with your $120K Business Grant — from the AI Horse-Powered POD platform to cinematic ads and the Best of Best Directory.
        </p>
        
        <button 
          onClick={scrollToFeatures}
          className="inline-flex flex-col items-center gap-2 text-cyan-400 hover:text-cyan-300 transition-colors group"
        >
          <span className="text-sm font-medium">Explore Features</span>
          <div className="w-10 h-10 rounded-full border-2 border-cyan-400/50 group-hover:border-cyan-300 flex items-center justify-center animate-bounce">
            <ChevronDown className="w-5 h-5" />
          </div>
        </button>
      </div>
    </section>
  );
};

export default ScrollForMore;
